import { EditorObject } from './editor-object.model';
import { IFloor } from './interfaces/iFloor.interface';

export class EditorFloor implements IFloor {
    floorType: number;
    elements: EditorObject[] = [];
}
